import { useState, ChangeEvent, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { OTP, resendOtp } from "../../graphql/mutations/otp";
import {
  OtpContainer,
  OtpBackgroundImage,
  HeaderContainer,
  BackContainer,
  GoBackText,
  OtpModal,
  OtpTextContainer,
  OtpInformation,
  OtpCreateText,
  OtpInputContainer,
  OtpInput,
  OtpFormContainer,
  ResendCodeContainer,
  ResendCodeText,
  ButtonContainer,
} from "./otp.styles";
import Buttons from "../../components/Button/button.component";
import { colors } from "../../theme/color";
import { useDispatch, useSelector } from "react-redux";
import { setFirstModalOpen } from "../../store/modal/modalSlice";
import { getData, setLocalStorageData } from "../../utils/localStorage";
import { LoadingSpinner, Overlay } from "../AddUserPage/AddUser";
import { toast } from "react-toastify";
import { loginAction } from "../../store/auth/authSlice";
import { RootState } from "../../store/rootReducer";
import { setUserData } from "../../store/user";
import { router } from "../../utils/general";

const Otp = () => {
  const [verifyUser, { loading }] = useMutation(OTP);
  const [resendOtpAction] = useMutation(resendOtp);
  const navigate = useNavigate();
  const [otpValues, setOtpValues] = useState(["", "", "", "", "", ""]);
  const dispatch = useDispatch();
  const { id, email } = useSelector(
    (state: RootState) => state.user?.user || {}
  );
  const TokenId = id;

  const NavigateToLogin = () => {
    navigate("/auth/signup/personal");
  };

  const NavigateToDashboard = () => {
    router("/dashboard/home");
  };

  const otpInputs = useRef<HTMLInputElement[]>([]);

  const handleOtpChange = (index: number, value: string) => {
    const newValue = value.charAt(0);
    const updatedOtpValues = [...otpValues];
    updatedOtpValues[index] = newValue;
    setOtpValues(updatedOtpValues);
    if (newValue && index < otpInputs.current.length - 1) {
      otpInputs.current[index + 1].focus();
    } else if (!newValue && index > 0) {
      otpInputs.current[index - 1].focus();
    }
  };

  const handleKeyDown = (
    index: number,
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === "Backspace" && index > 0 && !otpValues[index]) {
      event.preventDefault();
      const updatedOtpValues = [...otpValues];
      updatedOtpValues[index - 1] = "";
      setOtpValues(updatedOtpValues);
      otpInputs.current[index - 1].focus();
    }
  };

  const isFormValid = () => {
    return otpValues.every((value) => value !== "");
  };

  const handleOtp = async () => {
    try {
      const enteredOtp = otpValues.join("");
      const response = await verifyUser({
        variables: {
          verifyUserId: TokenId,
          otp: enteredOtp,
        },
      });
      console.log("response", response);
      // const accessToken = response.data.verifyUser.accessToken;
      // const refreshToken = response.data.verifyUser.refreshToken;
      // if (response.data.verifyUser.success === true) {

      if (response.data.verifyUser.success === true) {
        const { accessToken, refreshToken } = response.data.verifyUser;
        dispatch(loginAction({ accessToken, refreshToken }));
        dispatch(setFirstModalOpen(true));
        NavigateToDashboard();
      }
    } catch (error) {
      console.log(error);
      toast.error("Invalid OTP or OTP expired", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };
  const emailFromStorage = email;

  const handleResendOtp = async () => {
    if (!emailFromStorage) return;

    setOtpValues(["", "", "", "", "", ""]);
    try {
      const response = await resendOtpAction({
        variables: {
          email: emailFromStorage,
        },
      });
      if (
        response.data.resendOTPByEmail.message ===
        `OTP resent to ${emailFromStorage}`
      ) {
        toast.success("OTP sent successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error("Invalid OTP or OTP expired", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <OtpContainer>
      {loading && (
        <Overlay>
          <LoadingSpinner />
        </Overlay>
      )}
      <OtpBackgroundImage>
        <img src="/assets/icons/hero-landingPage.png" alt="Hero Landing Page" />
      </OtpBackgroundImage>
      <HeaderContainer>
        <img src="/assets/icons/fipaylogo.png" alt="Fipay Logo" />
      </HeaderContainer>
      <BackContainer>
        <img src="/assets/svg/goBack.svg" alt="Back Arrow" />
        <GoBackText onClick={NavigateToLogin}>Go back</GoBackText>
      </BackContainer>
      <OtpModal>
        <OtpTextContainer>
          <OtpInformation>We just sent you an email</OtpInformation>
          <OtpCreateText>
            Enter the OTP code we sent to {emailFromStorage} to confirm your
            email address
          </OtpCreateText>
        </OtpTextContainer>
        <OtpFormContainer>
          <OtpInputContainer className="otpInput">
            {otpValues.map((value, index) => (
              <OtpInput
                key={index}
                value={value}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  handleOtpChange(index, e.target.value)
                }
                onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
                  handleKeyDown(index, e)
                }
                type="text"
                maxLength={1}
                ref={(ref) => {
                  if (ref) {
                    otpInputs.current[index] = ref;
                  }
                }}
              />
            ))}
          </OtpInputContainer>
        </OtpFormContainer>
        <ResendCodeContainer>
          <ResendCodeText onClick={handleResendOtp}>
            Resend code?
          </ResendCodeText>
        </ResendCodeContainer>
        <ButtonContainer>
          <Buttons
            label="Confirm email address"
            width="83%"
            color={colors.ButtonBackgroundColors.primaryMediumHoverButton}
            cursor="pointer"
            border="15px"
            height="40px"
            disabled={!isFormValid()}
            handleClick={handleOtp}
          />
        </ButtonContainer>
      </OtpModal>
    </OtpContainer>
  );
};

export default Otp;
